module.exports = {
    'Tablet': 768,
    'DesktopSm': 992,
    'Desktop': 1200
};